import { ref } from 'vue'
import { useUserStore } from '@/lib/stores'
import { FeatureConfig } from '@/lib/services'
import {DEFAULT_ALERT} from '@/lib/utils/constants'

export interface AlertModalData {
  show: boolean
  key: string
  count: number
  message: string
  title: string
  subtitle: string
  description: string
}

export const AlertModalService = () => {
  const packageFeatures = ref<FeatureConfig[]>([])
  const state = ref<AlertModalData>({
    show: false,
    key: '',
    count: 0,
    message: '',
    title: '',
    subtitle: '',
    description: '',
  })

  function getState(): AlertModalData {
    return state.value
  }

  function showAlert(
    key: string = '', 
    count: number = 0, 
    message?: string, 
    hidePopup: boolean = false,
    title?: string,
    subtitle?: string,
    description?: string
  ): boolean {
    if (state.value.show) {
      return false
    }

    // If no key provided, skip validation and just show the modal
    if (!key) {
      state.value.key = ''
      state.value.count = 0
      state.value.message = message || ''
      state.value.title = title || DEFAULT_ALERT.title
      state.value.subtitle = subtitle || DEFAULT_ALERT.subtitle
      state.value.description = description || message || DEFAULT_ALERT.description
      state.value.show = !hidePopup
      return true
    }

    // Feature validation logic when key is provided
    if(packageFeatures.value.length === 0) {
      const userStore = useUserStore()
      const packages = userStore.getTrailPackageFeatures
      Object.values(packages).forEach((pack: any) => {
        pack.features?.forEach((feature: FeatureConfig) => {
          packageFeatures.value.push(feature)
        })
      })
    }
    try {
      const feature = packageFeatures.value.find((feature: FeatureConfig) => feature.feature_key === key)
      
      if(!feature || feature.value_type !== 'limit') {
        return false
      }
      
      if(count < Number(feature.value) || Number(feature.value) === -1) {
        return false // limit not reached
      }
      
      // Limit reached - show modal
      state.value.key = key
      state.value.count = count
      state.value.message = message || ''
      state.value.title = title || DEFAULT_ALERT.title
      state.value.subtitle = subtitle || DEFAULT_ALERT.subtitle
      state.value.description = description || message || DEFAULT_ALERT.description
      state.value.show = !hidePopup
      
      return true
    } catch (error) {
      console.error('Error showing modal:', error)
      return false
    }
  }

  function hide(): void {
    state.value.show = false
    state.value.key = ''
    state.value.count = 0
    state.value.message = ''
    state.value.title = ''
    state.value.subtitle = ''
    state.value.description = ''
  }

  return {
    hide,
    showAlert,
    getState,
    state
  };
}

export const alertModalService = AlertModalService();
